export default [
  {
    name: 'Petit déjeuner',
    portions: 3
  },
  {
    name: 'Déjeuner',
    portions: 5
  },
  {
    name: 'Goûter',
    portions: 2
  },
  {
    name: 'Dîner',
    portions: 5
  }
];
